export default "__VITE_ASSET___1Qy1kY___"